import React, { useEffect, useRef } from 'react';
import videojs from 'video.js';
import Player from 'video.js/dist/types/player';
import 'video.js/dist/video-js.css';
import Box from '@mui/material/Box';
import { SxStyle } from '../../../../types';

interface Props {
  options: any; // https://videojs.com/guides/options
  onReady?: (player: Player) => void;
}

const styles: SxStyle = {
  player: {
    height: '480px',
    width: '270px',
    '& .vjs-tech': {
      borderRadius: 4,
    },
    '& .video-js': {
      borderRadius: 4,
    },
    '& .video-js .vjs-button': {
      display: 'none',
    },
    '& .video-js .vjs-remaining-time': {
      display: 'none',
    },
    '& .video-js .vjs-volume-panel': {
      display: 'none',
    },
    '& .video-js .vjs-control-bar': {
      backgroundColor: 'transparent',
      paddingBottom: '4px',
    },
    '& .video-js .vjs-progress-control:hover .vjs-mouse-display': {
      display: 'none',
    },
    '& .video-js .vjs-progress-control:hover .vjs-time-tooltip': {
      display: 'none',
    },
    '& .video-js .vjs-progress-control': {
      paddingLeft: '4px',
      paddingRight: '4px',
    },
  },
};

export const VideoPlayer = ({ options, onReady }: Props) => {
  const videoRef = useRef<HTMLDivElement | null>(null);
  const playerRef = useRef<Player | null>(null);

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement('video-js');
      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current!.appendChild(videoElement);

      playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(playerRef.current!);
      });
    }

    return () => {
      if (playerRef.current && !playerRef.current.isDisposed()) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [onReady, options, videoRef]);

  return (
    <Box sx={styles.player} data-vjs-player>
      <Box ref={videoRef} />
    </Box>
  );
};

export default VideoPlayer;
